<template>
  <div class="page-main">
    <div v-if="loginLoading" class="loading-mask">
      <div class="chase"></div>
      <div class="loading-text">正在登录，请稍后...</div>
    </div>
    <div class="login_container">
      <div class="login_box">
        <el-row>
          <el-col :span="18" :offset="3">
            <!-- <img class="login_logo" src="../assets/image/login-logo.png" /> -->
            <div class="login_logo">高性能计算平台</div>
            <el-form
              v-if="formView"
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="54px"
              :label-position="labelPosition"
            >
              <el-form-item prop="username" label="账号">
                <el-input
                  type="text"
                  v-model="ruleForm.username"
                  autocomplete="off"
                  placeholder="请输入账户"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="password" label="密码">
                <el-input
                  type="password"
                  v-model="ruleForm.password"
                  placeholder="请输入密码"
                  autocomplete="off"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="verificationCode" class="input_ver">
                <el-col :span="10">
                  <el-input
                    v-model="ruleForm.verificationCode"
                    placeholder="请输入验证码"
                    @keyup.enter.native="goLogin('ruleForm')"
                  ></el-input>
                </el-col>
                <el-col :span="14" align="right">
                  <img
                    :src="qrcodeSrc"
                    style="max-width:150px"
                    @click="getVerifyGrccode"
                  />
                </el-col>
              </el-form-item>
            </el-form>
            <el-row style="text-align: center">
              <el-col :span="formView ? 24 : 12" align="right">
                <el-button type="text" @click="forgetPassword"
                  >忘记密码</el-button
                >
              </el-col>
            </el-row>
            <div class="login-btn-container" v-if="formView">
              <el-button
                class="loginBtn"
                type="primary"
                :loading="loginLoading"
                @click.native.prevent="goLogin('ruleForm')"
                >登 录</el-button
              >
            </div>
            <div
              class="unit-login-btn"
              v-if="formView"
              style="cursor:pointer"
              @click="goLink"
            >
              统一认证入口<i
                class="el-icon-arrow-right"
                style="fontWeight:bold"
              ></i>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="qrcode-box">
        <div>
          <div class="code-item">
            <div><img class="" src="../assets/image/core_code.jpg" /></div>
            <div>公众号二维码</div>
          </div>
          <div class="code-item">
            <div><img class="" src="../assets/image/core_code.jpg" /></div>
            <div>APP二维码</div>
          </div>
        </div>
      </div>
      <div class="footer-bottom"></div>
    </div>
  </div>
</template>
<script>
import { lib } from "../assets/js/lib";
import QRCode from "qrcodejs2";
export default {
  components: {
    QRCode
  },
  name: "Login",
  data() {
    return {
      ruleForm: {
        username: "",
        password: "",
        verificationCode: ""
      },
      loginLoading: false,
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 5,
            max: 16,
            message: "用户名由5-16位的英文字母数字下划线组成",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "密码由7-15位的字母数字下划线组成",
            trigger: "blur"
          }
        ],
        verificationCode: [
          {
            required: true,
            message: "验证码错误",
            trigger: "blur"
          }
        ]
      },
      formView: true,
      qrcodeSrc: "/sso/captcha?r=" + new Date().valueOf(),
      labelPosition: "left"
    };
  },
  mounted() {},
  destroyed() {},
  methods: {
    getVerifyGrccode() {
      this.ruleForm.verificationCode = "";
      this.qrcodeSrc = "/sso/captcha?r=" + new Date().valueOf();
    },
    goLogin(formName) {
      //点击登录
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loginLoading = true;
          this.http
            .post("/sso/security_check", this.ruleForm, {
              headers: {
                Authorization: "Basic U2FtcGxlQ2xpZW50SWQ6dGdiLjI1OA==",
                "api-login": lib.config.apiLogin,
                loginFlag: true
              }
            })
            .then(res => {
              if (res.data.status === -1) {
                this.$message.error(res.data.message);
                this.getVerifyGrccode();
                return false;
              }
              let data = res.data;
              lib.cookie.set("Hpc-Platform-Token", data.data.access_token);
              const current = this;
              this.loginSuccess(data.data, function(res) {
                //页面跳转
                let avatar = res.data.avatar
                  ? res.data.avatar
                  : "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png";
                current.$store.commit("updateUser", {
                  name: res.data.name,
                  username: res.data.username,
                  userProperty: res.data.userProperty,
                  avatar: avatar,
                  balance: res.data.balance
                });
                const clusters = res.data.clusters;
                if (clusters) {
                  current.$store.commit("updateClusters", clusters);
                  current.$store.commit("updatecurrentCluster", {
                    clusterName: clusters[0].clusterName
                  });
                  lib.cookie.set("HEAD-CLUSTER-NAME", clusters[0].clusterName);
                }
                lib.sessionStorage.set("name", res.data.name);
                lib.sessionStorage.set("avatar", avatar);
                lib.sessionStorage.set("username", res.data.username);
                lib.sessionStorage.set("userProperty", res.data.userProperty);
                lib.sessionStorage.set("balance", res.data.balance);
                current.$router.replace("/");
                window.store = current.$store;
                this.loginLoading = false;
              });
            })
            .finally(() => {
              this.loginLoading = false;
            });
        } else {
          this.getVerifyGrccode();
          return false;
        }
      });
    },
    loginSuccess(data, callback) {
      var stores = this.$store;
      //拉取菜单列表
      this.http.get("/client/user/menus", {}).then(res => {
        let menus = [];
        menus.push({
          id: "-1",
          name: "首页",
          clientPath: "/index"
        });
        menus = menus.concat(res.data);
        // this.$router.addRouter("Home", (route: RouteConfig));
        this.$store.commit("updateMenus", menus);
        let menusString = JSON.stringify(menus);
        lib.sessionStorage.set("menus", menusString);
        this.http.get("/client/user/summary-info", {}).then(res => {
          callback(res);
        });
      });
    },
    forgetPassword() {
      this.$router.push({ path: "/forget-password" });
    },
    showQrcode() {
      this.formView = false;
      this.$nextTick(function() {
        this.qrcode();
      });
    },
    goLink() {
      //南航2期
      //window.location.href = 'https://authserver.nuaa.edu.cn/authserver/login?service=https://hpcpt2.nuaa.edu.cn/'
      //南航1期
      window.location.href =
        "https://authserver.nuaa.edu.cn/authserver/login?service=https://hpcpt.nuaa.edu.cn/";
    }
  },
  created() {
    let _that = this;
    lib.errCatch = function(data) {
      _that.$message.error(data.message);
    };
    document.onkeydown = function(e) {
      let key = window.event.keyCode;
      if (key === 13) {
        _that.goLogin("ruleForm");
      }
    };
    //微信扫码登陆重定向
    if (this.$route.query.code) {
      this.http.post("/wxLogin", { code: this.$route.query.code }).then(res => {
        if (res.code != 1) {
          this.$message.error("登录失败");
        }
        this.loginSuccess(res.data);
        this.setToken(res.data.Token);
        this.$router.replace("/");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-main {
  flex-grow: 1;
  //background-color: #e9eef3;
}

.login_container {
  background: url("../assets/image/login-bg-1.png") no-repeat;
  background-size: 100% 100%;
  height: 100%;
}

.login_box {
  width: 400px;
  height: 430px;
  // background: rgba(200, 200, 200, 0.2);
  background: #ffffff;
  border-radius: 3px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 50%;
  transform: translate(0, -50%);

  // & /deep/ .el-input__inner {
  //   border: none;
  //   border-bottom: 1px solid #fff;
  //   background: none;
  //   border-radius: 0;
  //   color: #fff;
  // }
  & /deep/ .el-input__inner {
    border: none;
    background: inherit;
    border-radius: 0;
    color: #606266;
  }

  & /deep/ .el-form-item__label {
    color: #606266;
    padding: 0 0 0 16px;

    &::before {
      display: none;
    }
  }

  .el-form-item {
    background: #f7f7f7;
    height: 40px;
  }
}

.unit-login-btn {
  color: #1c9399;
  text-align: right;
  margin-top: 20px;
  font-size: 14px;
}

.loginBtn {
  width: 100%;
}

.login_logo {
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin: 30px 0 24px 0;
  color: #1c9399;
}

.login-btn-container {
  position: relative;
  margin-top: 16px;
}

.switch-qrcodeBtn {
  position: absolute;
  right: -3px;
  bottom: -1px;
  z-index: 99;
  color: #000;
  height: 15px;
}

.qrcode_img {
  width: 100%;
}

.footer-bottom {
  overflow: hidden;
  width: 100%;
  height: 30px;
  padding: 20px 0;
  position: fixed;
  bottom: 0;
}

.footer-bottom p {
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  line-height: 39px;
}

.qrcode-box {
  position: fixed;
  bottom: 20px;
  display: flex;
  justify-content: center;
  width: 100%;

  > div {
    display: flex;
  }

  .code-item {
    text-align: center;
    font-size: 12px;

    &:last-child {
      margin-left: 20px;
    }

    img {
      width: 100px;
      height: 100px;
    }
  }
}
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.loading-text {
  margin-top: 100px;
  color: #fff;
  font-size: 16px;
  padding-left: 40px;
}
.chase {
  position: relative;
}
.chase:after,
.chase:before {
  content: "";
  height: 30px;
  width: 30px;
  display: block;
  -webkit-animation: out 0.5s backwards, spin 1.25s 0.5s infinite ease;
  animation: out 0.5s backwards, spin 1.25s 0.5s infinite ease;
  border: 5px solid #fff;
  border-radius: 100%;
  -webkit-box-shadow: 0 -40px 0 -5px #fff;
  box-shadow: 0 -40px 0 -5px #fff;
  position: absolute;
}
.chase:after {
  -webkit-animation-delay: 0s, 1.25s;
  animation-delay: 0s, 1.25s;
}

@-webkit-keyframes out {
  from {
    -webkit-box-shadow: 0 0 0 -5px #fff;
    box-shadow: 0 0 0 -5px #fff;
  }
}

@keyframes out {
  from {
    -webkit-box-shadow: 0 0 0 -5px #fff;
    box-shadow: 0 0 0 -5px #fff;
  }
}

@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
<style lang="scss">
.login_box {
  .el-input__inner::-webkit-input-placeholder {
    color: #c0c4cc !important;
  }

  .el-input__inner::-moz-placeholder {
    color: #c0c4cc !important;
  }

  .el-input__inner::-ms-input-placeholder {
    color: #c0c4cc !important;
  }

  .el-input__inner::placeholder {
    color: #c0c4cc !important;
  }

  .input_ver {
    .el-form-item__content {
      margin-left: 0 !important;
      display: flex;
      height: 40px;
    }
  }
}

.code {
  text-align: center;
}

.code img {
  display: inline-block !important;
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/comm/views/Login4Workspace1.vue